var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.drawerVisible,
        "with-header": true,
        "append-to-body": "",
        size: "560px",
        title: "修改客人名单",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "guest-edit-page",
        },
        [
          _c("div", { staticClass: "info-header" }, [
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("订单编号：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.orderChildId)),
              ]),
            ]),
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("入住酒店：")]),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.hotelName)),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "action-btns" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-download", size: "small" },
                  on: { click: _vm.handleDownloadTemplate },
                },
                [_vm._v("下载上传名单模板")]
              ),
              _c(
                "el-upload",
                {
                  attrs: {
                    "http-request": _vm.uploadGuestFile,
                    "show-file-list": false,
                    accept: ".xlsx,.xls",
                    action: "#",
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { icon: "el-icon-paperclip", size: "small" } },
                    [_vm._v("上传名单")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.roomListData, function (stay, sIdx) {
            return _c(
              "div",
              { key: sIdx, staticClass: "stay-list" },
              [
                _c("div", { staticClass: "stay-title" }, [
                  _vm._v(
                    _vm._s(stay.checkinDate) + " → " + _vm._s(stay.checkoutDate)
                  ),
                ]),
                _vm._l(stay.roomList, function (room, rIdx) {
                  return _c(
                    "div",
                    { key: rIdx, staticClass: "room-block" },
                    [
                      _c("div", { staticClass: "room-type-header" }, [
                        _c("span", { staticClass: "room-type-name" }, [
                          _vm._v(_vm._s(room.roomName || "Standard Room")),
                        ]),
                        _c("span", { staticClass: "room-count" }, [
                          _vm._v(_vm._s(stay.roomList.length) + " 间"),
                        ]),
                      ]),
                      _c("div", { staticClass: "room-label-row" }, [
                        _c("span", { staticClass: "room-label" }, [
                          _vm._v("房间 " + _vm._s(room.roomNumber || rIdx + 1)),
                        ]),
                      ]),
                      _vm._l(room.customInfos, function (guest, gIdx) {
                        return _c(
                          "div",
                          { key: gIdx, staticClass: "guest-item" },
                          [
                            _c("div", { staticClass: "guest-row" }, [
                              _c(
                                "div",
                                { staticClass: "guest-field" },
                                [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("中文名"),
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入中文名",
                                      size: "small",
                                    },
                                    model: {
                                      value: guest.name,
                                      callback: function ($$v) {
                                        _vm.$set(guest, "name", $$v)
                                      },
                                      expression: "guest.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "guest-field" },
                                [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("英文名"),
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入英文名",
                                      size: "small",
                                    },
                                    model: {
                                      value: guest.nameEn,
                                      callback: function ($$v) {
                                        _vm.$set(guest, "nameEn", $$v)
                                      },
                                      expression: "guest.nameEn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "guest-row" }, [
                              _c(
                                "div",
                                { staticClass: "guest-field" },
                                [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("性别"),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { size: "small" },
                                      model: {
                                        value: guest.sex,
                                        callback: function ($$v) {
                                          _vm.$set(guest, "sex", $$v)
                                        },
                                        expression: "guest.sex",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "男", value: "男" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "女", value: "女" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "guest-field" },
                                [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("身份证号/护照号"),
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入身份证号或护照号",
                                      size: "small",
                                    },
                                    model: {
                                      value: guest.passprotNumber,
                                      callback: function ($$v) {
                                        _vm.$set(guest, "passprotNumber", $$v)
                                      },
                                      expression: "guest.passprotNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "guest-actions" },
                              [
                                room.customInfos.length > 1
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          underline: false,
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeGuest(
                                              sIdx,
                                              rIdx,
                                              gIdx
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除 ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "add-btn",
                          on: {
                            click: function ($event) {
                              return _vm.addGuest(sIdx, rIdx)
                            },
                          },
                        },
                        [_c("span", [_vm._v("+ 添加入住人")])]
                      ),
                    ],
                    2
                  )
                }),
              ],
              2
            )
          }),
          _c(
            "div",
            { staticClass: "bottom-bar" },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "100%",
                    height: "44px",
                    "font-size": "15px",
                    "font-weight": "700",
                  },
                  attrs: { loading: _vm.saving, type: "primary" },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保 存 ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }